var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBoxMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85597 17.2696L4.85597 15.3649C3.94837 14.7886 3.49457 14.5005 3.24728 14.0506C3 13.6007 3 13.0631 3 11.988V9.27383C3 8.4991 3 8.00351 3.09254 7.6187L9.25 12.0169V18.084C8.88422 17.9225 8.45669 17.651 7.85597 17.2696ZM10.75 18.084C11.1158 17.9225 11.5433 17.651 12.144 17.2696L15.144 15.3649L15.144 15.3649C16.0516 14.7886 16.5054 14.5005 16.7527 14.0506C17 13.6007 17 13.0631 17 11.988V9.27383C17 8.4991 17 8.00351 16.9075 7.6187L10.75 12.0169V18.084ZM15.9765 6.44031L10 10.7092L4.02348 6.44031C4.24737 6.2834 4.52071 6.10985 4.85597 5.89698L4.85597 5.89698L7.85597 3.99222C8.8978 3.33074 9.41871 3 10 3C10.5813 3 11.1022 3.33074 12.144 3.99222L15.144 5.89698L15.144 5.89699C15.4793 6.10985 15.7526 6.2834 15.9765 6.44031Z",
    fill: "#1B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoxMedium);
export default __webpack_public_path__ + "static/media/ic_box_medium.4bc9f8e5f2805421edb62df731ed43aa.svg";
export { ForwardRef as ReactComponent };